/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

// MY CLIENT CALL OUT //
export const getCcoList = (params) => makeApiCall(`/cnc/client-call-outs`, 'GET', params);

export const getCcoListExport = (params) =>
  makeApiCall(`/cnc/client-call-outs/export`, 'GET', params);

export const getAccountList = (params) => makeApiCall(`/cnc/accounts`, 'GET', params);

export const postCreateClientCallOut = (params) =>
  makeApiCall(`/cnc/client-call-outs`, 'POST', params);

export const getViewCco = (params) =>
  makeApiCall(`/cnc/client-call-outs/${params?.id}`, 'GET', params);

export const getMoeList = (params) => makeApiCall(`/cnc/moe`, 'GET', params);

export const getCollectionStatusList = (params) =>
  makeApiCall(`/cnc/collection-status`, 'GET', params);

export const getCncLatestFieldEngagement = (params) =>
  makeApiCall(`/cnc/latest-field-engagement`, 'GET', params);

export const getCncLastClientCallOuts = (params) =>
  makeApiCall(`/cnc/client-call-outs/latest`, 'GET', params);

export const getCncCreditAccessment = (params) =>
  makeApiCall(`/cnc/credit-assessment`, 'POST', params);

export const getCncAgingSummary = (params) => makeApiCall(`/cnc/aging-summary`, 'POST', params);

export const patchCcoUpdate = (params) =>
  makeApiCall(`/cnc/client-call-outs/${params.id}`, 'PATCH', params);

// MY CLIENT CALL OUT //

// CLIENT CALL OUT DASHBOARD //
export const getCncDashboard = (params) =>
  makeApiCall(`/cnc/client-call-outs/dashboard`, 'GET', params);

export const getCncDashboardDetails = (params) =>
  makeApiCall(`/cnc/client-call-outs/dashboard/details`, 'GET', params);

export const getCncDashboardMoe = (params) =>
  makeApiCall(`/cnc/client-call-outs/dashboard/moe`, 'GET', params);

// CLIENT CALL OUT DASHBOARD //
export const postDeleteAttachment = (params) =>
  makeApiCall(`/cnc/client-call-outs/attachment/delete/${params.id}`, 'DELETE', params);

export const getCncAccountList = (params) =>
  makeApiCall(`/cnc/client-call-outs-with-pdc`, 'GET', params);

export const getCncAccountListv2 = (params) => makeApiCall(`/cnc/client-call-outs`, 'GET', params);

export const getClienCallOutShow = (params) =>
  makeApiCall(`/cnc/client-call-outs/show`, 'GET', params);

export const postClienCallOutStore = (params) =>
  makeApiCall(`/cnc/client-call-outs`, 'POST', params);

// ENGAGEMENT
export const getClientCalloutLatest = (params) =>
  makeApiCall(`/cnc/client-call-outs/latest`, 'GET', params);

export const getClientCalloutField = (params) =>
  makeApiCall(`/cnc/latest-field-engagement`, 'GET', params);
